<template>
  <FilterDropdown :options="options" @select:change="onChange" />
</template>

<script lang="ts">
import type { SelectOptions } from '@/types/Components/SelectOptions'
import { defineComponent } from 'vue'
import { ACTIVE, ALL, ARCHIVED } from '@/const/ArchiveModes'
import { ARCHIVE_MODE } from '@/const/AssignmentListQueryFilters'
import { useAssignmentStore } from '@/store/assignment'
import FilterDropdown from '@/views/Components/PageParts/FilterDropdown.vue'

export default defineComponent({
  name: 'ArchiveModeFilter',
  components: { FilterDropdown },
  setup() {
    const assignmentStore = useAssignmentStore()

    const options: SelectOptions[] = [
      { value: ACTIVE, text: 'Active' },
      { value: ARCHIVED, text: 'Archived' },
      { value: ALL, text: 'Active + Archived' },
    ]
    const onChange = (value: string) => {
      assignmentStore.updateFilterValue({ key: ARCHIVE_MODE, value })
    }

    return {
      onChange,
      options,
    }
  },
})
</script>
